const words = {
  spanish: {
    title: "PLANES",
    description1: "APROVECHA!!!",
    description2: "ESTA TEMPORADA Y DISFRUTE DEL VALLE DE COCORA",
    description4:
      "QUE LE OFRECE EL RESTAURANTE LAS PALMAS DE COCORA. NO LO DEJES PASAR.",
    description5: "CUMPLEAÑOS: ",
    description6:
      "celebra tu cumpleaños en el RESTAURANTE LAS PALMAS DE COCORA, presenta tu cédula y de cortesía de la casa te invitamos a un delicioso POSTRE de tu elección.",
    description7:
      "Porfavor no dudes en contactarnos para obtener toda la información sobre la cotización de nuestros planes.",
    includes: "Incluye: ",
    ownStyleTitle: "Plan Estilo Propio",
    ownStyleText1:
      "Disfruta, vive y aprende del valle del cocora y la trucha arco iris con el plan al estilo propio, OPORTUNIDAD QUE NO PUEDES DEJAR PASAR",
    ownStyleText2:
      "Ven y disfruta del eco-hotel Las Palmas de Cocora, incluso si no tienes un plan, aquí encontrarás un menú con diferentes preparaciones de trucha, carnes y algo típico, paisajes hermosos y una experiencia inolvidable.",
    friendsTitle: "Plan Básico Amigos",
    friendsText:
      "Este plan está dirigido a las personas que quieran vivir una experiencia llena de diversión y aventuras.",
    friendsArrival: "Bienvenida con aperitivos",
    friendsLunch: "Almuerzo",
    friendsRefreshment: "Refrigerio",
    birthdayTitle: "Plan Cumpleaños",
    birthdayDesc1:
      "Celebra tu día especial en un entorno rural y acogedor en nuestro restaurante campestre. Ofrecemos una amplia variedad de opciones de menú y un ambiente perfecto para una fiesta de cumpleaños única e inolvidable.",
    birthdayDesc2:
      "Nos aseguramos de darte una experiencia inolvidable en el día en el que la persona más importante eres tú! Nos haremos cargo de decorar y de tener todo listo para su llegada y la de sus invitados!",
  },
  english: {
    title: "PACKAGES",
    description1: "PROFIT!!!",
    description2: "THIS SEASON ENJOY COCORA VALLEY ",
    description4:
      "THAT THE RESTAURANT LAS PALMAS OFFERS YOU. 'DON'T LET IT SLIP'.",
    description5: "BIRTHDAY: ",
    description6:
      "celebrate your birthday in the Restaurant LAS PALMAS DE COCORA, show us your ID and we'll give you a free dessert!!",
    description7:
      "Please do not hesitate to contact us for all the information on the pricing of our plans.",
    includes: "Includes: ",
    ownStyleTitle: "Package My Own Style",
    ownStyleText1:
      "Enjoy, live and learn about the Cocora Valley and the rainbow trout with this package, a once in a lifetime opportunity.",
    ownStyleText2:
      "Come and enjoy of the Eco-Hotel Las Palmas de Cocora, even if you don't have a plan, here you'll a menu with different kinds of trout, meat and typical cuisine, beautiful landscapes and an unforgetable experience.",
    friendsTitle: "Package Friends Only",
    friendsText:
      "This package is for those who want to live an experience full of fun and adventures.",
    friendsArrival: "Welcome to the restaurant with appetizers",
    friendsLunch: "Lunch",
    friendsRefreshment: "Little treats",
    birthdayTitle: "Birthday Package",
    birthdayDesc1:
      "Celebrate the most special day of the year in a cozy rural setting at our country side restaurant. We offer a wide range of menu options and the perfect atmosphere for a unique and unforgettable birthday party.",
    birthdayDesc2:
      "We make sure to give you an unforgettable experience on the day when you are the most important person! We will take care of decorating and having everything ready for your arrival and that of your guests!",
  },
};

export default words;
